(function() {
  const ELM_openCustomOrderFormBtns = document.querySelectorAll('[open-customized-order-form]');
  const ELM_closeCustomOrderFormBtns = document.querySelectorAll('[close-customized-order-form]');
  const ELM_customizedOrderForm = document.querySelector('.customized-order-form-section');
  if (ELM_customizedOrderForm) {
    ELM_openCustomOrderFormBtns?.forEach(btn => btn.addEventListener('click', () => {
      ELM_customizedOrderForm.classList.add('open');
    }));
    ELM_closeCustomOrderFormBtns?.forEach(btn => btn.addEventListener('click', () => {
      ELM_customizedOrderForm.classList.remove('open');
    }))
  }
})();

function backToTop() {
  const ELM_backToTop = document.querySelector('.back-to-top');
  if (!ELM_backToTop) return;
  if (window.scrollY > 400) {
    ELM_backToTop.classList.remove('hidden');
  } else {
    ELM_backToTop.classList.add('hidden');
  }
}
backToTop();

window.addEventListener('scroll', () => {
  backToTop();
})

class CustomizedOrderButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const ELM_customizedOrderForm = document.querySelector('.customized-order-form-section');
      console.log(ELM_customizedOrderForm);
      ELM_customizedOrderForm?.classList.add('open');
    })
  }
}
customElements.define('customized-order-button', CustomizedOrderButton);

class CollapsibleContent extends HTMLElement {
  constructor() {
    super();

    this.ELM_content = this.querySelector('[aria-collapsible-content]');
    this.ELM_readMoreButton = this.querySelector('[aria-read-more-button]');

    if (this.ELM_content.clientHeight + 5 < this.clientHeight) {
      this.toggle();
      this.querySelector('.collapsible-content__read-more')?.classList.add('hidden');
    } else {
      this.querySelector('.collapsible-content__read-more')?.classList.remove('hidden');
    }

    this.ELM_readMoreButton?.addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    this.classList.toggle('collapsed');
    const newLabel = this.ELM_readMoreButton.getAttribute('data-label');
    this.ELM_readMoreButton.setAttribute('data-label', this.ELM_readMoreButton.innerHTML);
    this.ELM_readMoreButton.innerHTML = newLabel;
  }
}
customElements.define('collapsible-content', CollapsibleContent);

function addParamToUrl(url, paramKey, paramValue) {
  let newUrl = url;
  if (url.includes('?')) {
    newUrl += `&${ paramKey }=${ paramValue }`;
  } else {
    newUrl += `?${ paramKey }=${ paramValue }`;
  }
  
  return newUrl;
}

function handleProductCardUrl(link) {
  const url = link.getAttribute('href');
  const isCollectionPage = location.pathname.includes('/collections/');
  if (!isCollectionPage || url.includes('collection=')) return;
  
  const collectionHandle = location.pathname.split('collections/')[1];
  const newUrl = addParamToUrl(url, 'collection', collectionHandle);
  link.setAttribute('href', newUrl);
}

function bindProductCardLinkMouseEnter(link) {
  link.addEventListener('mouseover', () => handleProductCardUrl(link));
  link.addEventListener('click', e => e.stopPropagation());
}

if (theme.device.hasHover && theme.mediaMatches.md) {
  document.querySelectorAll('.boost-sd__product-item a[href^="/products/"]')?.forEach((link) => {
    bindProductCardLinkMouseEnter(link);
  });

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // Add event listener to new buttons
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            node.querySelectorAll('.boost-sd__product-item a[href^="/products/"]')?.forEach((link) => {
              bindProductCardLinkMouseEnter(link);
            });
          }
        });

        // Remove event listener from removed buttons
        mutation.removedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            node.querySelectorAll('.boost-sd__product-item a[href^="/products/"]')?.forEach((link) => {
              link.removeEventListener('mouseover', this.handleProductCardUrl);
            });
          }
        });
      });
    });

    // Start observing changes to the DOM
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

class WishlistPopup extends HTMLElement {
  constructor() {
    super();
    this.wishlist = null;
    this.ELM_header = this.querySelector('[e-wishlist-header]');
    this.ELM_container = this.querySelector('[e-wishlist-container]');
    this.ELM_closeButtons = this.querySelectorAll('[e-wishlist-close-button]');
    this.ELM_loadingScreen = this.querySelector('.loading-screen');
    const ELM_openButtons = document.querySelectorAll('[e-wishlist-open-button]');

    this.ELM_closeButtons?.forEach(btn => btn.addEventListener('click', this.close.bind(this)));
    ELM_openButtons?.forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault();
      this.fetchList(this.open.bind(this))
    }));

    this.handleSwymNoti(0);
  }

  handleSwymNoti(count = 0) {
    if (count > 19) return;
    const ELM_swymNoti = document.querySelector('.swym-wishlist-notifications-container');
    if (!ELM_swymNoti) {
      count += 1;
      return setTimeout(() => this.handleSwymNoti.bind(this)(count), 300);
    }

    ELM_swymNoti.addEventListener('click', () => {
      this.fetchList(this.open.bind(this));
    })
  }

  produceProductHandles() {
    if (!this.wishlist.listcontents || !this.wishlist.listcontents.length) return null;
    return this.wishlist.listcontents.map(item => item.du.split('/products/')[1].trim()).join(',');
  }

  renderHeader() {
    if (!this.wishlist) return;
    this.ELM_header.innerHTML = `<div class="swym-user-login-status"><span>${this.wishlist.cby}</span></div>`;
  }

  renderProducts(html) {
    if (!html) {
      this.ELM_container.innerHTML = `<div class="wishlist-popup-empty">
        <h3>Love It? Add to My Wishlist</h3>
        <div>My Wishlist allows you to keep track of all of your favorites and shopping activity whether you're on your computer, phone, or tablet. You won't have to waste time searching all over again for that item you loved on your phone the other day - it's all here in one place!</div>
        <div e-wishlist-close-button class="btn btn--primary">Continue shoping</div>
      </div>`;

      return this.ELM_container.querySelector('[e-wishlist-close-button]')?.addEventListener('click', this.close.bind(this));
    }

    this.ELM_container.innerHTML = html;
    const ELM_removeBtns = this.querySelectorAll('[e-wishlist-remove-button]');
    ELM_removeBtns?.forEach(btn => {
      // btn.removeEventListener('click', this.removeProduct)
      btn.addEventListener('click', () => this.removeProduct(btn));
    });
  }

  open() {
    const productHandles = this.produceProductHandles();
    const self = this;
    self.classList.add('open');
    if (!productHandles) {
      self.renderHeader();
      this.renderProducts();
      this.disableLoading();
      return;
    };
    fetch(`/pages/swym-share-wishlist?view=wishlist&products=${ productHandles }`)
      .then(res => res.text())
      .then(html => {
        self.renderHeader();
        self.renderProducts(html);
        self.disableLoading();
      })
  }

  close() {
    this.classList.remove('open');
  }

  enableLoading() {
    this.ELM_loadingScreen.classList.remove('hidden');
  }

  disableLoading() {
    this.ELM_loadingScreen.classList.add('hidden');
  }

  removeProduct(btn) {
    const self = this;
    const empi = btn.dataset.empi;
    if (!empi) return;
    const target = self.wishlist.listcontents.filter(item => item.empi.toString() === empi)[0];
    if (!target) return;
    const product = {
      epi: target.epi,
      empi: target.empi,
      du: target.du
    }
    async function swymCallbackFn(swat) {
      swat.deleteFromList(self.wishlist.lid, product, () => {
        const ELM_product = btn.closest('.wishlist-product');
        self.fetchList(self.open.bind(self));
      });
    }
    if(!window.SwymCallbacks) {
    window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }

  fetchList(cb) {
    const self = this;
    this.enableLoading();
    async function swymCallbackFn(swat) {
      swat.fetchLists({
        callbackFn: async (lists) => {
          self.wishlist = lists[0];
          cb();
        }
      });
    }
    if(!window.SwymCallbacks) {
    window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }
}
customElements.define('wishlist-popup', WishlistPopup);